import {
  EContractState,
  EOriginalAvailability,
} from "src/shared/types/partner.types";

export const originalAvailabilityColors: Record<
  EOriginalAvailability,
  "error" | "success" | "warning"
> = {
  [EOriginalAvailability.ABSENT]: "error",
  [EOriginalAvailability.IN_STOCK]: "success",
  [EOriginalAvailability.WIHOUT_DOCUMENTS]: "warning",
};

export const contractStateColors: Record<
  EContractState,
  "default" | "success" | "warning"
> = {
  [EContractState._0]: "default",
  [EContractState._1]: "default",
  [EContractState._2]: "success",
  [EContractState._3]: "default",
  [EContractState._4]: "warning",
  [EContractState._5]: "default",
  [EContractState._6]: "default",
  [EContractState._7]: "default",
};
